export enum ApiError {
  ExpiredToken = 'ExpiredToken',
  NoPreviousInstance = 'NoPreviousInstance',
}
